'use client';
import cookie from 'react-cookies';

// 用户是否登陆
export const getIsLogin = () => {
    const userinfo = cookie.load('userInfo');

    return !!userinfo?.token;
};
